import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { Video } from '../../../utils/api/videoApi';
import { breakpoints, Color, colors, spacing } from '../../../utils/styleguide';
import PrimaryButton, { ButtonColor } from '../buttons/PrimaryButton';
import VideoPlayButton from '../VideoPlayButton';
import { Col, Row } from './12ColGridLayout';

const Background = styled.section`
  background-color: ${(props: { backgroundColor?: string }) =>
    props.backgroundColor ?? colors.white};
  padding: ${spacing[10]}px 0;
  ${breakpoints.tablet} {
    padding: ${spacing[11]}px 0;
  }
`;

const StyledRow = styled(Row)`
  *:last-child {
    margin-bottom: 0;
  }
`;

const StyledText = styled.div`
  margin-bottom: ${spacing[6]}px;
`;

type BigParagraphLayoutProps = {
  id?: string;
  preamble: ReactNode;
  paragraph: ReactNode;
  buttonLabel?: string;
  href?: string;
  buttonColor?: ButtonColor;
  backgroundColor?: Color;
  portraitVideo?: Video;
  landscapeVideo?: Video;
  className?: string;
};

const BigParagraphLayout = ({
  id,
  preamble,
  paragraph,
  backgroundColor,
  buttonLabel,
  buttonColor = 'onLight',
  href,
  portraitVideo,
  landscapeVideo,
  className,
}: BigParagraphLayoutProps) => {
  const hasVideo = portraitVideo || landscapeVideo;
  return (
    <Background
      backgroundColor={backgroundColor && colors[backgroundColor]}
      id={id}
      className={className}
    >
      <StyledRow>
        <Col desktop="3 / span 8">
          <StyledText>{preamble}</StyledText>
          <StyledText>{paragraph}</StyledText>

          {buttonLabel && !hasVideo && (
            <PrimaryButton
              color={buttonColor}
              label={buttonLabel}
              tag="a"
              href={href}
              size="large"
              css={css`
                display: inline-block;
                margin-bottom: ${spacing[6]}px;
              `}
            />
          )}
          {hasVideo && (
            <VideoPlayButton
              buttonLabel={buttonLabel}
              portraitVideo={portraitVideo}
              landscapeVideo={landscapeVideo}
            />
          )}
        </Col>
      </StyledRow>
    </Background>
  );
};

export default BigParagraphLayout;
